export const helpModalContent = {
  title: 'Need help using Bridge?',
  support: {
    heading: 'Chat to our support team!',
    phone: '021 824 3343',
    email: 'support@gometroapp.com',
  },
  releaseNotes: {
    heading: 'Release Notes',
    label: 'View Release Notes',
    url: 'https://gometroapp.com/bridge-release-notes/',
  },
} as const
